import { Icon } from 'src/components/Icon';
import { SVG_SIZE_XXXL } from 'src/constants';
import styles from './GreetingTitle.module.scss';
import { useBreakpoint } from 'src/hooks';

export const GreetingTitle = () => {
  const { isMobile } = useBreakpoint();

  return (
    <h1 className={styles.root}>
      <Icon type="ninjaMainIcon" size={isMobile ? 52 : SVG_SIZE_XXXL} />
      Ninja
    </h1>
  );
};
